import { View, Text, TouchableOpacity, StyleSheet } from 'react-native';
import { useAuth } from '@/hooks/useAuth';

export default function WaitingScreen() {
  const { signOut } = useAuth();

  return (
    <View style={styles.screen}>
      <Text style={styles.icon}>🏋️</Text>
      <Text style={styles.title}>Aguardando seu personal</Text>
      <Text style={styles.subtitle}>
        Seu personal está preparando tudo para você.{'\n'}
        Em breve seu treino estará pronto!
      </Text>
      <TouchableOpacity style={styles.signOutBtn} onPress={signOut}>
        <Text style={styles.signOutText}>Sair</Text>
      </TouchableOpacity>
    </View>
  );
}

const styles = StyleSheet.create({
  screen: {
    flex: 1, backgroundColor: '#0D0D0D',
    justifyContent: 'center', alignItems: 'center', padding: 32,
  },
  icon: { fontSize: 64, marginBottom: 24 },
  title: {
    fontSize: 22, fontWeight: '700', color: '#fff',
    textAlign: 'center', marginBottom: 12,
  },
  subtitle: {
    fontSize: 15, color: '#888', textAlign: 'center', lineHeight: 22, marginBottom: 48,
  },
  signOutBtn: { padding: 12 },
  signOutText: { fontSize: 14, color: '#555' },
});
